import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Clients, TradeTypes } from '../../../services/globals.service';
import { JobDataService } from '../../../services/job-data.service';
import { BookingWindow } from '../../../triage/triage.component';
import { environment } from '../../../../environments/environment';
import { MetaDataService } from '../../../services/meta-data.service';

@Component({
  selector: 'triage-question-confirmation',
  templateUrl: './triage-question-confirmation.component.html',
  styleUrls: ['./triage-question-confirmation.component.css', './../../../triage/triage.component.css']
})
export class TriageQuestionConfirmationComponent implements OnInit {
  
  @Input() discountApplied: boolean;
  @Input() estimatedDuration: number;
  @Input() fullPrice: number;
  @Input() currentPrice: number;
  @Input() discountText: string;
  @Input() outOfHoursPriceApplied: boolean;
  @Input() bookingWindows: Array<BookingWindow>;
  @Input() clientID: number;
  @Input() pricingInfoEnabled: boolean;
  @Input() bookingWindowsEnabled: boolean;
  
  @Output() goToStepTypeEvent = new EventEmitter<number>();

  constructor(
    public jobDataService: JobDataService,
    public tradeTypes: TradeTypes,
    public clients: Clients,
    public metaDataService: MetaDataService
  ) { }

  ngOnInit() {
  }
  
  public goToStepType(type: number): void {
    this.goToStepTypeEvent.emit(type);
  }

}
